import axios from 'axios';
import CreateAccess from './createAccess';
import AccessResource from './resource';

export const List = (signal?: AbortSignal) => axios.get<AccessResource[]>('/api/Access', { signal });

export const Create = (model: CreateAccess, signal?: AbortSignal) => axios.post<AccessResource>('/api/Access', model, { signal });

export const Delete = (token: string, signal?: AbortSignal) => axios.delete(`/api/Access/${token}`, { signal });
